import type { TFunction } from 'i18next'
import type { FanProfile } from '../chat/useFan'

/**
 * The header's presence line (chats.js getChatFanPresence): "Available now"
 * when OnlyFans says the fan is online, "Last seen …" from lastSeen, and
 * nothing at all rather than a guess.
 */
export function presenceOf(p: FanProfile | null, t: TFunction, now = Date.now()): { online: boolean; label: string } | null {
  if (!p) return null
  if (p.isOnline || String(p.lastSeen ?? '').toLowerCase() === 'online') return { online: true, label: t('header.online') }
  const at = Date.parse(p.lastSeen ?? '')
  if (!Number.isFinite(at)) return null
  const sec = Math.max(0, Math.round((now - at) / 1000))
  const ago =
    sec < 60
      ? t('header.justNow')
      : sec < 3600
        ? t('header.minutesAgo', { count: Math.round(sec / 60) })
        : sec < 86400
          ? t('header.hoursAgo', { count: Math.round(sec / 3600) })
          : new Date(at).toLocaleDateString(undefined, { day: 'numeric', month: 'short' })
  return { online: false, label: t('header.lastSeen', { ago }) }
}
